import { LessonMaterialFragment_alternativeMaterials } from './__generated__/LessonMaterialFragment';
import { LessonMaterialSmallText } from 'approot/shared/lesson-materials/lesson-materials-list.style';

const LessonMaterialsAlternatives = ({
  alternativeMaterials,
  dataSelector,
}: {
  alternativeMaterials: LessonMaterialFragment_alternativeMaterials[];
  dataSelector?: string;
}) => (
  <LessonMaterialSmallText marginBottom={0} data-selector={dataSelector}>
    {`Alternative Materials: ${alternativeMaterials
      .map(am => am.name)
      .join(', ')}`}
  </LessonMaterialSmallText>
);

export default LessonMaterialsAlternatives;
